import React, { Component } from 'react';

class MeetSelect extends Component {
  getMeetSelect() {
    const meets = this.props.meets.map((meet) =>
      <option key={meet.meet_id} value={meet.meet_id}>{meet.date}</option>
    );
    return <span className="medium-3 large-2 columns no-margin"><select id="meet_filter" value={this.props.meetFilter} onChange={this.props.handleMeetChange}>
      {meets}
      </select></span>;
  }
  render() {
    return (
      <span>
        {this.getMeetSelect()}
      </span>
    );
  }
}

export default MeetSelect;
